import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Flex } from '@chakra-ui/react';
/** The brand's question, in a cream bubble on the right, its tail corner tucked in. */
export function UserBubble({ text }) {
    return (_jsx(Flex, { justify: "flex-end", children: _jsx(Box, { maxW: "85%", px: "3.5", py: "2.5", borderRadius: "xl", borderEndEndRadius: "sm", bg: "agent.subtle", fontSize: "sm", lineHeight: "1.5", color: "agent.fg", whiteSpace: "pre-wrap", overflowWrap: "anywhere", children: text }) }));
}
